export enum ServiceType {
  GENERAL,
  CONNECT,
  CLOSET,
}
